export default __webpack_public_path__ + "static/media/Agenda-Ferris-Wheel_normal.3f99f94e.png";